import React from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import { DeviceProvider } from './DeviceProvider/DeviceContext';
import { ViewportProvider } from './ViewportProvider/ViewportContext';
import { queryConfig } from '../../../play-core/api/query-config';
import { DebugProvider } from '../../src/components/Debug/DebugContext';
import { AnalyticsProvider } from '../analytics/AnalyticsContext';
import { BottomDialogProvider } from '../components/BottomDialog/BottomDialogContext';
import { DialogProvider } from '../components/Dialog/DialogContext';
import { LoadingBarProvider } from '../components/LoadingBar/LoadingBarProvider';
import { MobileDialogProvider } from '../components/MobileDialog/MobileDialogContext';
import { SnackbarProvider } from '../components/Snackbar/SnackbarContext';
import { jsx as _jsx } from "react/jsx-runtime";
export const GlobalProviders = ({
  children
}) => /*#__PURE__*/_jsx(QueryClientProvider, {
  client: queryConfig,
  children: /*#__PURE__*/_jsx(DebugProvider, {
    children: /*#__PURE__*/_jsx(DeviceProvider, {
      children: /*#__PURE__*/_jsx(ViewportProvider, {
        children: /*#__PURE__*/_jsx(AnalyticsProvider, {
          children: /*#__PURE__*/_jsx(LoadingBarProvider, {
            children: /*#__PURE__*/_jsx(SnackbarProvider, {
              children: /*#__PURE__*/_jsx(DialogProvider, {
                children: /*#__PURE__*/_jsx(BottomDialogProvider, {
                  children: /*#__PURE__*/_jsx(MobileDialogProvider, {
                    children: children
                  })
                })
              })
            })
          })
        })
      })
    })
  })
});